module.exports = __webpack_public_path__ + "img/CS3-2.9bd22285.png";